<i *ngIf="qrCodeSrc == null" class="fal fa-circle-notch fa-4x fa-spin"></i>
<img [title]="'QR-Code für die DLP App'" [ngClass]="smallIcon == true ? 'smallIconPosition' : ''" [height]="smallIcon == false ? 300 : 125" [width]="smallIcon == false ? 300 : 125" [hidden]="qrCodeSrc == null" [src]="qrCodeSrc" />

<div [style]="dlBtnStyle" (click)="downloadQRCode()" [hidden]="!showDLBtn && qrCodeSrc != null" [title]="'Download QR-Code'" class="downloadQRDiv">
    Download App QR-Code
</div>

<a id="qrcodegenerator_a_get_absolute_url"></a>